module.exports = __webpack_public_path__ + "static/img/BQ.bed11784.svg";